function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable react-hooks/exhaustive-deps */
import { useField, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import { FormGroup } from 'reactstrap';
import { Error, Label } from "./";
import api from "../../services/api";
import Logger from "../../services/logger";
import getResource from "../../services/resources";
import { t } from "../../services/translator";
import helper from "./select/helper";

var Autocomplete = function Autocomplete(props) {
  // props
  var resource = props.resource,
      display = props.display,
      name = props.name,
      tag = props.tag,
      size = props.size,
      multiple = props.multiple,
      clearable = props.clearable,
      value = props.value,
      hasLabel = props.hasLabel,
      onChange = props.onChange,
      autoload = props.autoload; // hooks

  var _useField = useField({
    name: name
  }),
      _useField2 = _slicedToArray(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      fieldHelper = _useField2[2];

  var _useFormikContext = useFormikContext(),
      submitCount = _useFormikContext.submitCount; // state


  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      timer = _useState4[0],
      setTimer = _useState4[1]; // var


  var invalid = name ? (meta.touched || submitCount > 0) && meta.error !== undefined : false;
  /**
   * Format value or received options (from api)
   * used in fetchOptions and useEffect.
   *
   * @param {array} collection
   */

  var formatCollectionToOptions = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(collection, isMultiple) {
      var isSettingValue,
          response,
          objCollection,
          i,
          entity,
          _response,
          obj,
          _args = arguments;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isSettingValue = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;

              if (!Array.isArray(collection) && (multiple || isMultiple)) {
                collection = [collection];
              }

              response = null;

              if (!(multiple || isMultiple)) {
                _context.next = 28;
                break;
              }

              objCollection = [];
              i = 0;

            case 6:
              if (!(i < collection.length)) {
                _context.next = 24;
                break;
              }

              if (!(_typeof(collection[i]) === 'object')) {
                _context.next = 17;
                break;
              }

              entity = collection[i];

              if (!(!entity[display] && entity['@id'])) {
                _context.next = 14;
                break;
              }

              _context.next = 12;
              return api.get(entity['@id']);

            case 12:
              _response = _context.sent;
              entity = _response.data;

            case 14:
              objCollection.push({
                label: entity[display],
                value: entity
              });
              _context.next = 21;
              break;

            case 17:
              _context.next = 19;
              return api.get(collection[i]);

            case 19:
              response = _context.sent;

              if (response.data) {
                objCollection.push({
                  label: response.data[display],
                  value: response.data
                });
              }

            case 21:
              i++;
              _context.next = 6;
              break;

            case 24:
              if (!isSettingValue) {
                _context.next = 27;
                break;
              }

              setValues(objCollection);
              return _context.abrupt("return");

            case 27:
              return _context.abrupt("return", objCollection);

            case 28:
              obj = collection;

              if (!(_typeof(collection) !== 'object')) {
                _context.next = 34;
                break;
              }

              _context.next = 32;
              return api.get(collection);

            case 32:
              response = _context.sent;

              if (response.data) {
                obj = response.data;
              }

            case 34:
              if (isSettingValue) {
                setValues({
                  label: t(obj[display] || ''),
                  value: obj
                });
              }

              return _context.abrupt("return", {
                label: t(obj[display] || ''),
                value: obj
              });

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function formatCollectionToOptions(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * @param {string} terms
   */


  var fetchOptions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(terms) {
      var response;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return getResource(resource).list(_defineProperty({}, tag, terms));

            case 3:
              response = _context2.sent;
              return _context2.abrupt("return", formatCollectionToOptions(response['hydra:member'], true));

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              Logger.error('Autocomplete', 'option', _context2.t0);
              return _context2.abrupt("return", []);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function fetchOptions(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * @param {string} value
   */


  var loadAsyncOptions = function loadAsyncOptions(terms) {
    clearTimeout(timer);
    return new Promise(function (resolve) {
      var newTimer = setTimeout(function () {
        resolve(fetchOptions(terms));
      }, 500);
      setTimer(newTimer);
    });
  };
  /**
   * @param {array} options
   */


  var handleOnChange = function handleOnChange(options) {
    if (!options) {
      return;
    }

    var optionsToValue = [];

    if (multiple) {
      options.map(function (option) {
        return optionsToValue.push(option.value['@id']);
      });
    } else {
      optionsToValue = options.value['@id'];
    }

    setValues(options);

    if (onChange && typeof onChange === 'function') {
      onChange(optionsToValue);
    }

    if (name) {
      fieldHelper.setValue(optionsToValue);
    }
  }; // load values with existing one.


  useEffect(function () {
    if (!field || !field.value) {
      return;
    }

    formatCollectionToOptions(field.value, multiple, true);
  }, []);
  useEffect(function () {
    if (!value) {
      return;
    }

    formatCollectionToOptions(value, multiple, true);
  }, [value]);
  return /*#__PURE__*/React.createElement(FormGroup, null, name && hasLabel && /*#__PURE__*/React.createElement(Label, {
    name: name,
    size: size
  }, name), /*#__PURE__*/React.createElement(AsyncSelect, {
    isMulti: multiple,
    isClearable: clearable,
    cacheOptions: true,
    loadOptions: loadAsyncOptions,
    invalid: invalid,
    onChange: handleOnChange,
    value: values,
    onBlur: function onBlur() {
      return name && fieldHelper.setTouched(true);
    },
    styles: helper.buildStyles(size, invalid),
    defaultOptions: autoload,
    className: "autocomplete-async"
  }), name && /*#__PURE__*/React.createElement(Error, {
    name: name
  }));
};

Autocomplete.propTypes = {
  size: PropTypes.string,
  resource: PropTypes.string.isRequired,
  display: PropTypes.string.isRequired,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
  tag: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  clearable: PropTypes.bool,
  autoload: PropTypes.bool,
  hasLabel: PropTypes.bool
};
Autocomplete.defaultProps = {
  size: 'sm',
  multiple: false,
  clearable: false,
  autoload: false,
  hasLabel: true,
  name: null,
  value: null
};
export default Autocomplete;